/* The part details sheet behind the fit check picker.

   WHY THIS IS NOT AN IFRAME OF THE PRODUCT PAGE. Dropping /products/handle
   into a frame pulls the whole store shell in with it: header, cart drawer,
   footer, the VIN app, the fit check modal we are already standing inside. So
   this fetches the product JSON and draws only the part of it a person needs
   to answer "is this the right thing", which is the pictures, the part number,
   the name and the description.

   NO PRICE, AND THAT IS DELIBERATE. A signed in dealer sees a 20% trade price
   on the real product page, so a retail number in here would contradict the
   page they are one tap away from. assets/fx-search.js leaves it out of the
   suggestions list for the same reason. If price ever goes in here it has to
   come from the same source the product page uses, not from the JSON.

   IT RENDERS ON document.body, NOT INSIDE THE DIALOG. The extension's
   .vcp-form__dialog clips and scrolls its own content, so a sheet rendered
   inside it is trapped in the column and scrolls away with the form. Same rule
   as the zoom overlay below it.

   AND YET IT LOOKS LIKE IT IS INSIDE (29 Oct). It used to be a second full
   window modal with its own backdrop and its own round close button sitting
   about a hundred pixels under the form's one, which left two identical
   crosses on screen and nothing saying which shut which. anchor() now measures
   the dialog's rect and positions this over it, so the sheet rises inside the
   form's own box with the form's close button still the only one. The root
   carries pointer-events: none and only the sheet takes the pointer, so the
   strip of form left showing above it stays live, and showTop() scrolls that
   column to the top as the sheet opens so what shows is the heading and the
   parts already chosen rather than wherever the reader happened to be.

   The support page has no dialog, so there anchor() falls back to the old
   centred card and its backdrop. Same markup, one class different.

   IT OWNS NO STATE. The selection lives in assets/fx-fitpart.js and is reached
   through window.fxFitApi. This file reads has() to decide what the button
   says and calls add() or removeByUrl() when it is pressed, so there is one
   list and one place that can change it. */
(function () {
  'use strict';

  var ZOOM_Z = 'fxpd-zoom';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    var swapped = url.replace(/([?&])width=[0-9]+/, '$1width=' + w);
    if (swapped !== url) return swapped;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function api() {
    return window.fxFitApi || null;
  }

  /* THE EXTENSION CLOSES ITS MODAL ON ANY CLICK OUTSIDE ITS OWN DIALOG, and
     everything this file draws lives on document.body, which is outside it. So
     every tap in the details sheet read as "they clicked away" and shut the fit
     check form behind it: close the sheet and the form was gone too.

     Stopping the events at our own root keeps them off the extension's
     document level listener. It has to cover the pointer and mouse events as
     well as click, because a close handler that waits for click is the
     exception, not the rule. */
  function seal(el) {
    var types = ['pointerdown', 'mousedown', 'touchstart', 'click'];
    for (var i = 0; i < types.length; i++) {
      el.addEventListener(types[i], function (e) { e.stopPropagation(); });
    }
  }

  /* ----------------------------------------------------------- anchor -- */

  /* Over the dialog, not in it. Everything the sheet needs to sit inside the
     form modal's rectangle is three numbers and an offset, and all four are
     read fresh: the extension builds and destroys that dialog as it opens and
     closes, and HubSpot resizes the iframe inside it after every render.

     The offset is how much of the form stays showing above the sheet. A fixed
     number is wrong at both ends, a tall desktop modal and a short phone one,
     so it is a share of the height with a floor and a ceiling. At 28 per cent
     a 700px dialog keeps 196px, which is the heading and the first chip. */
  function dialogEl() {
    return document.querySelector('.vcp-form__dialog');
  }

  function anchor(root) {
    var d = dialogEl();
    var r = d && d.getBoundingClientRect();
    if (!r || !r.width || !r.height) {
      root.classList.add('fxpd--loose');
      root.removeAttribute('style');
      return;
    }
    root.classList.remove('fxpd--loose');
    var off = Math.max(120, Math.min(236, Math.round(r.height * 0.28)));
    root.style.left = Math.round(r.left) + 'px';
    root.style.top = Math.round(r.top) + 'px';
    root.style.width = Math.round(r.width) + 'px';
    root.style.height = Math.round(r.height) + 'px';
    /* inset: 0 in the stylesheet sets all four edges. left plus width plus
       right is over constrained and right loses, but saying so is cheaper
       than relying on that. */
    root.style.right = 'auto';
    root.style.bottom = 'auto';
    root.style.setProperty('--fxpd-off', off + 'px');
  }

  var unfollow = null;

  function stopFollow() {
    if (!unfollow) return;
    unfollow();
    unfollow = null;
  }

  function startFollow(root) {
    stopFollow();
    var tick = function () {
      if (document.body.contains(root)) anchor(root);
      else stopFollow();
    };
    var ro = null;
    var d = dialogEl();
    if (d && window.ResizeObserver) {
      ro = new window.ResizeObserver(tick);
      ro.observe(d);
    }
    window.addEventListener('resize', tick);
    window.addEventListener('scroll', tick, true);
    /* The belt to the observer's braces. HubSpot resizes its frame on its own
       schedule and not every browser here has ResizeObserver. */
    var iv = window.setInterval(tick, 400);
    unfollow = function () {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', tick);
      window.removeEventListener('scroll', tick, true);
      window.clearInterval(iv);
    };
  }

  /* The strip of form above the sheet is only worth showing if it is the top
     of the form. Whatever scrolls inside the dialog goes back to zero. */
  function showTop() {
    var d = dialogEl();
    if (!d) return;
    var all = [d].concat(Array.prototype.slice.call(d.querySelectorAll('*')));
    for (var i = 0; i < all.length; i++) {
      if (all[i].scrollHeight > all[i].clientHeight + 4) all[i].scrollTop = 0;
    }
  }

  /* ------------------------------------------------------------- zoom -- */

  function closeZoom() {
    var z = document.getElementById(ZOOM_Z);
    if (z) z.parentNode.removeChild(z);
  }

  function openZoom(src, caption) {
    if (!src) return;
    closeZoom();
    var z = document.createElement('div');
    z.className = 'fxpp-lb';
    z.id = ZOOM_Z;
    z.innerHTML =
      '<button class="fxpp-lb__x" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<figure class="fxpp-lb__fig"><img src="' + esc(sized(src, 1600)) + '" alt="">' +
      '<figcaption>' + esc(caption) + '</figcaption></figure>';
    z.addEventListener('click', closeZoom);
    seal(z);
    document.body.appendChild(z);
  }

  /* ------------------------------------------------------------ sheet -- */

  var open = null;

  function close() {
    closeZoom();
    stopFollow();
    var el = document.querySelector('[data-fxp-detail]');
    if (el) el.parentNode.removeChild(el);
    open = null;
  }

  /* The strip of form above the sheet stays live, so somebody can tab or click
     straight back into the search field with the sheet still covering the
     results it would fill. Treat that as going back. */
  document.addEventListener('focusin', function (e) {
    if (!open) return;
    var root = document.querySelector('[data-fxp-detail]');
    if (!root || root.classList.contains('fxpd--loose')) return;
    if (root.contains(e.target)) return;
    var d = dialogEl();
    if (d && d.contains(e.target)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* The zoom sits on top of the sheet, so the first Escape closes the
       picture and the second closes the sheet. Closing both at once loses the
       part they were looking at. */
    if (document.getElementById(ZOOM_Z)) { closeZoom(); return; }
    if (open) close();
  });

  /* "Add" in the results row and "Add to my enquiry" here were two names for
     one action. The row keeps the short one, this keeps the long one, and they
     are now the same verb and the same noun. */
  function actionHtml(part) {
    var a = api();
    var inList = !!(a && a.has(part.url));
    return '<button class="fxpd__btn' + (inList ? ' fxpd__btn--out' : '') + '" type="button" ' +
      'data-fxpd-act>' + (inList ? 'Remove from enquiry' : 'Add to enquiry') + '</button>';
  }

  function shell(part) {
    return '<div class="fxpd__back" data-fxpd-close></div>' +
      '<div class="fxpd__fade" aria-hidden="true"></div>' +
      '<div class="fxpd__sheet" role="dialog" aria-label="Part details">' +
      '<div class="fxpd__nav">' +
      '<button class="fxpd__nav-btn" type="button" data-fxpd-close>' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
      'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M14 6l-6 6 6 6"/></svg>Back to results</button>' +
      '</div>' +
      '<div class="fxpd__body" data-fxpd-body>' +
      '<div class="fxpd__grid">' +
      '<div class="fxpd__shots">' +
      '<button class="fxpd__shot" type="button" data-fxpd-zoom aria-label="Expand image">' +
      (part.img
        ? '<img src="' + esc(sized(part.img, 900)) + '" alt="" data-fxpd-main>'
        : '<span class="fxpd__noimg"></span>') +
      '</button>' +
      '<div class="fxpd__strip" data-fxpd-strip></div>' +
      '</div>' +
      '<div class="fxpd__meta">' +
      '<p class="fxpd__sku" data-fxpd-sku>' + esc(part.sku || '') + '</p>' +
      '<h4 class="fxpd__t">' + esc(part.title) + '</h4>' +
      '<p class="fxpd__stock" data-fxpd-stock></p>' +
      '<div class="fxpd__desc" data-fxpd-desc><p class="fxpd__dim">Loading part details</p></div>' +
      '<a class="fxpd__link" href="' + esc(part.url) + '" target="_blank" rel="noopener">' +
      'Open the full part page' +
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" ' +
      'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/>' +
      '</svg></a>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="fxpd__foot" data-fxpd-foot>' + actionHtml(part) + '</div>' +
      '</div>';
  }

  /* Shopify's description is our own copy from our own store, but it is still
     markup going in through innerHTML, so the tags that could execute come out
     first. */
  function safeDesc(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    var bad = tmp.querySelectorAll('script, style, iframe, object, embed, form, input');
    for (var i = 0; i < bad.length; i++) bad[i].parentNode.removeChild(bad[i]);
    var links = tmp.querySelectorAll('a');
    for (var j = 0; j < links.length; j++) {
      links[j].setAttribute('target', '_blank');
      links[j].setAttribute('rel', 'noopener');
    }
    return tmp.innerHTML.trim();
  }

  function fill(sheet, part, data) {
    var sku = sheet.querySelector('[data-fxpd-sku]');
    var desc = sheet.querySelector('[data-fxpd-desc]');
    var strip = sheet.querySelector('[data-fxpd-strip]');
    var main = sheet.querySelector('[data-fxpd-main]');
    var stock = sheet.querySelector('[data-fxpd-stock]');

    var v = data && data.variants && data.variants[0];
    if (sku && v && v.sku) sku.textContent = v.sku;

    /* The results list says In stock on every row and the card somebody opens
       to decide was the one screen that did not. Only written once the product
       JSON has landed: an empty line is honest, a guessed one is not. */
    if (stock && data && typeof data.available === 'boolean') {
      stock.className = 'fxpd__stock ' + (data.available ? 'fxpd__stock--in' : 'fxpd__stock--out');
      stock.textContent = data.available ? 'In stock' : 'Out of stock';
    }

    if (desc) {
      var body = safeDesc(data && data.description);
      /* NOTHING RATHER THAN AN APOLOGY. This used to print "No description
         on file for this part", which reads as an admission that the
         catalogue is half finished, on the one screen where somebody is
         deciding whether to trust us with a part number. Enrichment is coming;
         until it lands, empty space says less and costs less. The picture, the
         part number and the name are all still here, and the full part page is
         one tap away. */
      desc.innerHTML = body;
    }

    var shots = (data && data.images) || [];
    if (!main && shots.length) {
      /* The suggest payload had no picture for this one but the product does,
         so the empty frame gets filled rather than left as a grey box. */
      var frame = sheet.querySelector('[data-fxpd-zoom]');
      if (frame) frame.innerHTML = '<img src="' + esc(sized(shots[0], 900)) + '" alt="" data-fxpd-main>';
      main = sheet.querySelector('[data-fxpd-main]');
    }

    if (strip && shots.length > 1) {
      strip.innerHTML = shots.slice(0, 6).map(function (s, i) {
        return '<button class="fxpd__tn' + (i === 0 ? ' is-on' : '') + '" type="button" ' +
          'data-fxpd-tn="' + esc(s) + '" aria-label="View image ' + (i + 1) + '">' +
          '<img src="' + esc(sized(s, 160)) + '" alt="" loading="lazy"></button>';
      }).join('');
    }
  }

  window.fxFitOpenDetail = function (part) {
    if (!part || !part.title) return;
    close();
    open = {
      title: part.title,
      sku: part.sku || '',
      url: part.url || '',
      img: part.img || ''
    };

    var sheet = document.createElement('div');
    sheet.className = 'fxpd';
    sheet.setAttribute('data-fxp-detail', '');
    sheet.innerHTML = shell(open);
    seal(sheet);
    document.body.appendChild(sheet);
    showTop();
    anchor(sheet);
    startFollow(sheet);
    /* One more pass after the browser has laid the sheet out. The dialog can
       still be settling when this runs, and a sheet anchored to a stale rect
       hangs off the modal by a few pixels, which looks like a bug. */
    window.requestAnimationFrame(function () {
      if (document.body.contains(sheet)) anchor(sheet);
    });

    sheet.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-fxpd-close]')) { close(); return; }

      var tn = t.closest('[data-fxpd-tn]');
      if (tn) {
        var src = tn.getAttribute('data-fxpd-tn');
        var main = sheet.querySelector('[data-fxpd-main]');
        if (main) main.setAttribute('src', sized(src, 900));
        open.img = src;
        var all = sheet.querySelectorAll('[data-fxpd-tn]');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('is-on');
        tn.classList.add('is-on');
        return;
      }

      if (t.closest('[data-fxpd-zoom]')) {
        openZoom(open.img, open.sku ? open.sku + ' - ' + open.title : open.title);
        return;
      }

      if (t.closest('[data-fxpd-act]')) {
        var a = api();
        if (!a) return;
        /* Removing leaves you here, because you may want another look at what
           you just took out. Adding is the end of this screen's job: the part
           is banked, the chip for it is already drawn in the strip above, and
           the next thing anyone wants is the results list again. */
        if (a.has(open.url)) {
          a.removeByUrl(open.url);
          var foot = sheet.querySelector('[data-fxpd-foot]');
          if (foot) foot.innerHTML = actionHtml(open);
          return;
        }
        a.add({ title: open.title, sku: open.sku, url: open.url, img: open.img });
        close();
      }
    });

    var handle = String(open.url || '').split('/products/')[1];
    if (!handle) return;
    fetch('/products/' + handle.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        /* They may have closed it, or opened a different part, while this was
           in flight. Writing into a sheet that is gone throws; writing into
           the wrong one is worse. */
        if (!open || open.url !== (part.url || '')) return;
        if (!document.body.contains(sheet)) return;
        if (data && data.variants && data.variants[0] && data.variants[0].sku) {
          open.sku = data.variants[0].sku;
        }
        if (!open.img && data && data.images && data.images[0]) open.img = data.images[0];
        fill(sheet, open, data);
      })
      .catch(function () {
        if (!document.body.contains(sheet)) return;
        var desc = sheet.querySelector('[data-fxpd-desc]');
        if (desc) {
          desc.innerHTML = '<p class="fxpd__dim">Could not load the details for this part. ' +
            'The full page link below still works.</p>';
        }
      });
  };
})();
